import { render, staticRenderFns } from "./EditReportDetails.vue?vue&type=template&id=8ab80a66&"
import script from "./EditReportDetails.vue?vue&type=script&lang=js&"
export * from "./EditReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditReportDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports